import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import {
  Button,
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
  TabsContent,
  Text,
  ViewModeTabs,
} from '@shared/ui';

export function ViewModeTabsShowcase() {
  const { t } = useTranslation();
  const [viewMode, setViewMode] = useState<'cards' | 'table'>('cards');

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t('uiLibrary.navigation.viewMode.title')}</CardTitle>
        <CardDescription>{t('uiLibrary.navigation.viewMode.description')}</CardDescription>
      </CardHeader>
      <CardContent>
        <ViewModeTabs
          value={viewMode}
          onValueChange={setViewMode}
          labels={{
            cards: t('analytics.weekly.views.cards', 'Cards'),
            table: t('analytics.weekly.views.table', 'Table'),
          }}
          toolbar={
            <>
              <Text size="sm" color="muted" className="text-center md:text-left">
                {t('uiLibrary.navigation.viewMode.toolbarHint')}
              </Text>
              <Button type="button" variant="outline">
                {t('uiLibrary.navigation.viewMode.toolbarAction')}
              </Button>
            </>
          }
        >
          <TabsContent value="cards" className="mt-4">
            <Text size="sm" color="muted">
              {t('uiLibrary.navigation.viewMode.cardsContent')}
            </Text>
          </TabsContent>
          <TabsContent value="table" className="mt-4">
            <Text size="sm" color="muted">
              {t('uiLibrary.navigation.viewMode.tableContent')}
            </Text>
          </TabsContent>
        </ViewModeTabs>
      </CardContent>
    </Card>
  );
}
